// extracted by mini-css-extract-plugin
export default {"root":"Resource_root__dexz5","spin":"Resource_spin__JAUql"};